import { useSelector } from 'react-redux';
import { useFetchActiveOffersQuery } from 'services/api/offer-auction';
import { useGetMyBidsQuery } from 'services/api/my-bids';

export const useBidsOfferAuction = (vehicleId: number) => {
  const { page, perPage, filters } = useSelector((state: any) => state.myBids);
  const { data: myBids } = useGetMyBidsQuery({ limit: perPage, offset: page, ...filters });

  const aaVehicles = myBids?.rows?.ids?.filter(id => myBids?.rows?.entities?.[id]?.auction?.type === 'autoaxess') || [];

  const { data: offerAuctions } = useFetchActiveOffersQuery(
    { vehicleIds: (aaVehicles as number[]) ?? [] },
    {
      skip: aaVehicles.length === 0
    }
  );

  const offerAuction = offerAuctions?.entities?.[vehicleId] ?? null;
  return offerAuction;
};
